<template>
<div class="aggregationPointConfig">
  <el-card shadow="never">{{ projectName }}</el-card>
  <div class="content">
    <div class="menuTree">
      <el-tree class="filter-tree" :data="treeData" :props="defaultProps" node-key="id" default-expand-all :default-checked-keys="[1]" highlight-current :expand-on-click-node="false" ref="tree" @node-click="handleNodeClick">
        <span class="custom-tree-node" slot-scope="{ node }">
          <span>
            <i class="el-icon-arrow-right" style="margin-right: 5px;"></i>{{ node.label }}
          </span>
        </span>
      </el-tree>
    </div>
    <div class="rightContent">
      <AggregationPointManagement v-if="treeId == 1" :projectId="projectId" :projectName="projectName"></AggregationPointManagement>
      <ConfigureAggregationPoints v-if="treeId == 2" :projectId="projectId" :projectName="projectName"></ConfigureAggregationPoints>
    </div>
  </div>
</div>
</template>

<script>
import AggregationPointManagement from './aggregationPointManagement.vue';
import ConfigureAggregationPoints from './configureAggregationPoints.vue';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      treeData: [{
        id: 1,
        label: '聚合点管理',
        children: []
      }, {
        id: 2,
        label: '系数配置聚合点',
        children: []
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      treeId: 1
    };
  },
  components: {
    AggregationPointManagement,
    ConfigureAggregationPoints
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.$refs.tree.setCurrentKey(1)
    })
  },
  methods: {
    handleNodeClick(data) {
      this.treeId = data.id;
    },
  }
};
</script>

<style lang="scss" scoped>
.aggregationPointConfig {
  width: 100%;
  height: 100%;
  padding-bottom: 10px;

  .content {
    padding: 20px 0px;
  }

  .menuTree {
    float: left;
    width: 200px;
    height: 65vh;

    .filter-tree {
      border-right: 1px solid;
      height: 98%;
      overflow: auto;
      padding-left: 10px;
    }

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      overflow-x: auto;
      padding-right: 25px;

      &::-webkit-scrollbar {
        height: 5px;
      }
    }

    >>> .el-tree-node__content {
      height: 40px;
      line-height: 25px;
    }

    >>> .el-tree-node__expand-icon.is-leaf {
      display: none;
    }
  }

  .rightContent {
    float: left;
    width: calc(100% - 200px);
    padding: 10px 0px 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/aggregationPointConfig.vue